import { iranSansxFaNum } from '@/ui/internalFonts'
import type { TypographyOptions } from '@mui/material/styles/createTypography'
import type { CSSProperties } from 'react'
declare module '@mui/material/styles' {
  export interface TypographyVariants {
    button1: CSSProperties
    button2: CSSProperties
    subtitle3: CSSProperties

    //New Design System

    //captionSmall
    captionSmallRegular__Wallfund: CSSProperties
    captionSmallMedium__Wallfund: CSSProperties
    captionSmallStrong__Wallfund: CSSProperties
    captionSmallHeavy__Wallfund: CSSProperties

    //caption
    captionLight__Wallfund: CSSProperties
    captionRegular__Wallfund: CSSProperties
    captionMedium__Wallfund: CSSProperties
    captionStrong__Wallfund: CSSProperties
    captionHeavy__Wallfund: CSSProperties

    //body
    bodyLight__Wallfund: CSSProperties
    bodyRegular__Wallfund: CSSProperties
    bodyMedium__Wallfund: CSSProperties
    bodyStrong__Wallfund: CSSProperties
    bodyHeavy__Wallfund: CSSProperties

    //bodyLarge
    bodyLargeLight__Wallfund: CSSProperties
    bodyLargeRegular__Wallfund: CSSProperties
    bodyLargeMedium__Wallfund: CSSProperties
    bodyLargeStrong__Wallfund: CSSProperties
    bodyLargeHeavy__Wallfund: CSSProperties

    //headline
    headlineLight__Wallfund: CSSProperties
    headlineRegular__Wallfund: CSSProperties
    headlineMedium__Wallfund: CSSProperties
    headlineStrong__Wallfund: CSSProperties
    headlineHeavy__Wallfund: CSSProperties

    //title
    titleLight__Wallfund: CSSProperties
    titleRegular__Wallfund: CSSProperties
    titleMedium__Wallfund: CSSProperties
    titleStrong__Wallfund: CSSProperties
    titleHeavy__Wallfund: CSSProperties

    //display
    displayLight__Wallfund: CSSProperties
    displayRegular__Wallfund: CSSProperties
    displayMedium__Wallfund: CSSProperties
    displayStrong__Wallfund: CSSProperties
    displayHeavy__Wallfund: CSSProperties



    //landing
    landingH1Medium__Wallfund: CSSProperties
    landingH1Strong__Wallfund: CSSProperties
    landingH2Strong__Wallfund: CSSProperties





    xxl: CSSProperties
    xl: CSSProperties

  }

  export interface TypographyVariantsOptions {
    button1?: CSSProperties
    button2?: CSSProperties
    subtitle3?: CSSProperties
    // New Design System

    //captionSmall
    captionSmallRegular__Wallfund: CSSProperties
    captionSmallMedium__Wallfund: CSSProperties
    captionSmallStrong__Wallfund: CSSProperties
    captionSmallHeavy__Wallfund: CSSProperties

    //caption
    captionLight__Wallfund: CSSProperties
    captionRegular__Wallfund: CSSProperties
    captionMedium__Wallfund: CSSProperties
    captionStrong__Wallfund: CSSProperties
    captionHeavy__Wallfund: CSSProperties

    //body
    bodyLight__Wallfund: CSSProperties
    bodyRegular__Wallfund: CSSProperties
    bodyMedium__Wallfund: CSSProperties
    bodyStrong__Wallfund: CSSProperties
    bodyHeavy__Wallfund: CSSProperties

    //bodyLarge
    bodyLargeLight__Wallfund: CSSProperties
    bodyLargeRegular__Wallfund: CSSProperties
    bodyLargeMedium__Wallfund: CSSProperties
    bodyLargeStrong__Wallfund: CSSProperties
    bodyLargeHeavy__Wallfund: CSSProperties

    //headline
    headlineLight__Wallfund: CSSProperties
    headlineRegular__Wallfund: CSSProperties
    headlineMedium__Wallfund: CSSProperties
    headlineStrong__Wallfund: CSSProperties
    headlineHeavy__Wallfund: CSSProperties

    //title
    titleLight__Wallfund: CSSProperties
    titleRegular__Wallfund: CSSProperties
    titleMedium__Wallfund: CSSProperties
    titleStrong__Wallfund: CSSProperties
    titleHeavy__Wallfund: CSSProperties

    //display
    displayLight__Wallfund: CSSProperties
    displayRegular__Wallfund: CSSProperties
    displayMedium__Wallfund: CSSProperties
    displayStrong__Wallfund: CSSProperties
    displayHeavy__Wallfund: CSSProperties

    landingH1Medium__Wallfund: CSSProperties
    landingH1Strong__Wallfund: CSSProperties
    landingH2Strong__Wallfund: CSSProperties

    xxl: CSSProperties
    xl: CSSProperties

  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    button1: true
    button2: true
    subtitle3: true



    // New Design System

    //captionSmall
    captionSmallRegular__Wallfund: true
    captionSmallMedium__Wallfund: true
    captionSmallStrong__Wallfund: true
    captionSmallHeavy__Wallfund: true

    //caption
    captionLight__Wallfund: true
    captionRegular__Wallfund: true
    captionMedium__Wallfund: true
    captionStrong__Wallfund: true
    captionHeavy__Wallfund: true

    //body
    bodyLight__Wallfund: true
    bodyRegular__Wallfund: true
    bodyMedium__Wallfund: true
    bodyStrong__Wallfund: true
    bodyHeavy__Wallfund: true

    //bodyLarge
    bodyLargeLight__Wallfund: true
    bodyLargeRegular__Wallfund: true
    bodyLargeMedium__Wallfund: true
    bodyLargeStrong__Wallfund: true
    bodyLargeHeavy__Wallfund: true

    //headline
    headlineLight__Wallfund: true
    headlineRegular__Wallfund: true
    headlineMedium__Wallfund: true
    headlineStrong__Wallfund: true
    headlineHeavy__Wallfund: true

    //title
    titleLight__Wallfund: true
    titleRegular__Wallfund: true
    titleMedium__Wallfund: true
    titleStrong__Wallfund: true
    titleHeavy__Wallfund: true

    //display
    displayLight__Wallfund: true
    displayRegular__Wallfund: true
    displayMedium__Wallfund: true
    displayStrong__Wallfund: true
    displayHeavy__Wallfund: true


    //landing ( temp )
    landingH1Medium__Wallfund: true
    landingH1Strong__Wallfund: true
    landingH2Strong__Wallfund: true

    xxl: true
    xl: true

  }
}

// const fontFamily = 'iransansx-fanum, sans-serif'
const fontFamily = iranSansxFaNum.style.fontFamily

const typographyOption: TypographyOptions = {
  fontFamily,
  h1: {
    fontSize: '3rem',
    fontWeight: 700,
    lineHeight: 1.667,
  },
  h2: {
    fontSize: '2.5rem',
    fontWeight: 700,
    lineHeight: 1.8,
  },
  h3: {
    fontSize: '2rem',
    fontWeight: 700,
    lineHeight: 1.75,
  },
  h4: {
    fontSize: '1.5rem',
    fontWeight: 700,
    lineHeight: 1.667,
  },
  h5: {
    fontSize: '1.25rem',
    fontWeight: 700,
    lineHeight: 1.8,
  },
  h6: {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.75,
  },
  subtitle1: {
    fontSize: '1rem',
    fontWeight: 500,
    lineHeight: 1.75,
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 500,
    lineHeight: 1.715,
  },
  subtitle3: {
    fontFamily,
    fontSize: '0.75rem',
    fontWeight: 500,
    lineHeight: 1.667,
  },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: 1.75,
  },
  body2: {
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: 1.715,
  },
  button: {
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.75,
  },
  button1: {
    fontFamily,
    fontSize: '1rem',
    fontWeight: 700,
    lineHeight: 1.75,
  },
  button2: {
    fontFamily,
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.715,
  },
  caption: {
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: 1.667,
  },
  overline: {
    fontSize: '0.625rem',
    fontWeight: 400,
    lineHeight: 1.6,
  },

  //caption
  captionLight__Wallfund: {
    fontSize: '12px',
    fontWeight: 200,
    lineHeight: '20px',
  },
  captionRegular__Wallfund: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  captionMedium__Wallfund: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: "20px",
  },
  captionStrong__Wallfund: {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: "20px",
  },
  captionHeavy__Wallfund: {
    fontSize: '12px',
    fontWeight: 950,
    lineHeight: "20px",
  },

  //captionSmall
  captionSmallRegular__Wallfund: {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: "16px",
  },
  captionSmallMedium__Wallfund: {
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: "16px",
  },
  captionSmallStrong__Wallfund: {
    fontSize: '10px',
    fontWeight: 700,
    lineHeight: "16px",
  },
  captionSmallHeavy__Wallfund: {
    fontSize: '10px',
    fontWeight: 950,
    lineHeight: "16px",
  },

  //body
  bodyLight__Wallfund: {
    fontSize: '14px',
    fontWeight: 200,
    lineHeight: "24px",
  },
  bodyRegular__Wallfund: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: "24px",
  },
  bodyMedium__Wallfund: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: "24px",
  },
  bodyStrong__Wallfund: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: "24px",
  },
  bodyHeavy__Wallfund: {
    fontSize: '14px',
    fontWeight: 950,
    lineHeight: "24px",
  },

  //bodyLarge
  bodyLargeLight__Wallfund: {
    fontSize: '16px',
    fontWeight: 200,
    lineHeight: "28px",
  },
  bodyLargeRegular__Wallfund: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: "28px",
  },
  bodyLargeMedium__Wallfund: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: "28px",
  },
  bodyLargeStrong__Wallfund: {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: "28px",
  },
  bodyLargeHeavy__Wallfund: {
    fontSize: '16px',
    fontWeight: 950,
    lineHeight: "28px",
  },


  //headline
  headlineLight__Wallfund: {
    fontSize: '20px',
    fontWeight: 200,
    lineHeight: "36px",
  },
  headlineRegular__Wallfund: {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: "36px",
  },
  headlineMedium__Wallfund: {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: "36px",
  },
  headlineStrong__Wallfund: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: "36px",
  },
  headlineHeavy__Wallfund: {
    fontSize: '20px',
    fontWeight: 950,
    lineHeight: "36px",
  },


  //title
  titleLight__Wallfund: {
    fontSize: '24px',
    fontWeight: 200,
    lineHeight: "40px",
  },
  titleRegular__Wallfund: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: "40px",
  },
  titleMedium__Wallfund: {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: "40px",
  },
  titleStrong__Wallfund: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: "40px",
  },
  titleHeavy__Wallfund: {
    fontSize: '24px',
    fontWeight: 950,
    lineHeight: "40px",
  },


  //display
  displayLight__Wallfund: {
    fontSize: '32px',
    fontWeight: 200,
    lineHeight: "48px",
  },
  displayRegular__Wallfund: {
    fontSize: '32px',
    fontWeight: 400,
    lineHeight: "48px",
  },
  displayMedium__Wallfund: {
    fontSize: '32px',
    fontWeight: 500,
    lineHeight: "48px",
  },
  displayStrong__Wallfund: {
    fontSize: '32px',
    fontWeight: 700,
    lineHeight: "48px",
  },
  displayHeavy__Wallfund: {
    fontSize: '32px',
    fontWeight: 950,
    lineHeight: "48px",
  },

  landingH1Medium__Wallfund: {
    fontSize: '48px',
    fontWeight: 500,
    lineHeight: "48px",
  },

  landingH1Strong__Wallfund: {
    fontSize: '48px',
    fontWeight: 700,
    lineHeight: "60px",
  },

  landingH2Strong__Wallfund: {
    fontSize: '40px',
    fontWeight: 700,
    lineHeight: "40px",
  },






  xl: {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: "28px",
  },
  xxl: {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: "36px",
  },

}

export const typography = typographyOption
